import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FilterListIcon from "@mui/icons-material/FilterList";
import { InventoryListTemplate } from "./InventoryListTemplate";

interface InventoryListHeaderProps {
  isFilterActive: boolean;
  onFilterToggle: () => void;
}

const HEADINGS: [string, string, "left" | "right"][] = [
  ["sku", "SKU", "left"],
  ["product", "PRODUCT", "left"],
  ["location", "LOCATION", "left"],
  ["status", "STATUS", "left"],
  ["cin7", "CIN7", "right"],
  ["threePl", "3PL", "right"],
  ["difference", "DIFF", "right"],
];

/**
 * The inventory list's column headings, with the filter toggle in the expand
 * column (a dot when a filter is applied).
 */
export const InventoryListHeader = (props: InventoryListHeaderProps) => {
  const { isFilterActive, onFilterToggle } = props;

  return (
    <InventoryListTemplate sx={{ pb: 1.5 }}>
      <IconButton
        aria-label="Filter inventory"
        onClick={onFilterToggle}
        size="small"
        sx={{
          gridArea: "expand",
          my: -0.5,
        }}
      >
        <Badge
          color="primary"
          invisible={!isFilterActive}
          variant="dot"
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>
      {HEADINGS.map(([area, label, align]) => (
        <Typography
          key={area}
          noWrap
          sx={{
            gridArea: area,
            textAlign: align,
          }}
          variant="subtitle2"
        >
          {label}
        </Typography>
      ))}
    </InventoryListTemplate>
  );
};
